import { render, staticRenderFns } from "./SellerContent.vue?vue&type=template&id=8fa044f0&scoped=true"
import script from "./SellerContent.vue?vue&type=script&lang=js"
export * from "./SellerContent.vue?vue&type=script&lang=js"
import style0 from "./SellerContent.vue?vue&type=style&index=0&id=8fa044f0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa044f0",
  null
  
)

export default component.exports